import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansDetailMinimumFeeComponent from './loansDetailMinimumFee.component';

let loansDetailMinimumFeeModule = angular.module('loansDetailMinimumFee', [
  uiRouter
])

.component('loansDetailMinimumFee', loansDetailMinimumFeeComponent)

.name;

export default loansDetailMinimumFeeModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailMinimumFee/loansDetailMinimumFee.js